import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';

import { ArrowDownward, ArrowUpward, Image } from '@material-ui/icons'; 

import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'; 
import iconAgredSpotfi from '../../../../../images/agregadores/spotify.png';
import iconAgredGoogle from '../../../../../images/agregadores/google.png';
import iconAgredItunes from '../../../../../images/agregadores/itunes.png'; 
import iconAgredPlay from '../../../../../images/play.svg';
import iconShare from '../../../../../images/share.svg';
import iconDownload from '../../../../../images/download.svg';


const useStyles = makeStyles(theme => ({
    root: {
       /*  height: '100%' */
    },
    content: {
        alignItems: 'center',
        display: 'flex'
    },
    title: {
        fontWeight: 700
    },
    avatar: {
        color: theme.palette.primary.main,
        height: 56,
        width: 56,
        backgroundColor: '#ffffff00',
    },
    icon: {
        height: '100%',
        width: '100%'
    },
    difference: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'center'
    },
    differenceIconDow: {
        color: theme.palette.error.dark
    },
    differenceValueDow: {
        color: theme.palette.error.dark,
        marginRight: theme.spacing(1)
    },
    differenceIconUP: {
        color: theme.palette.primary.dark
    },
    differenceValueUP: {
        color: theme.palette.primary.dark,
        marginRight: theme.spacing(1)
    }
}));

const Budget = props => {


    const { className, ...rest } = props;

    const classes = useStyles();

    let difTotal = props.playtotalcurdate - props.playtotalolddate;
    const percPositivo = difTotal > -1;

    const percentual = parseInt((Math.abs(difTotal) / (props.playtotalolddate > 0 ? props.playtotalolddate : 1)) * 100);

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent  >
                <Grid
                    container
                    justify="space-between"
                     
                >
                    <Grid item>
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                            variant="body2">
                            {rest.titulo}
                        </Typography>
                        <Typography variant="h3">{rest.playtotalcurdate}</Typography>
                    </Grid>
                    <Grid item>
                        {/* Mostrar o icone conforme o tipo do play */}
                        {rest.tipo == 'play' &&
                            <Avatar className={classes.avatar}>
                                <img src={iconAgredPlay} className={classes.icon} />
                            </Avatar>
                        }

                        {rest.tipo == 'spotify' &&
                            <Avatar className={classes.avatar}>
                                <img src={iconAgredSpotfi} className={classes.icon} />
                            </Avatar>
                        }

                         {rest.tipo == 'google' &&
                            <Avatar className={classes.avatar}>
                                <img src={iconAgredGoogle} className={classes.icon} />
                            </Avatar>
                        }
                        {rest.tipo == 'itunes' &&
                            <Avatar className={classes.avatar}>
                                <img src={iconAgredItunes} className={classes.icon} />
                            </Avatar>
                        }

                         {rest.tipo == 'share' &&
                            <Avatar className={classes.avatar}>
                                <img src={iconShare} className={classes.icon} />
                            </Avatar>
                        }
                          {rest.tipo == 'download' &&
                            <Avatar className={classes.avatar}>
                                <img src={iconDownload} className={classes.icon} />
                            </Avatar>
                        }

                        

                    </Grid>
                </Grid>

                {
                    !percPositivo &&
                    <div className={classes.difference}>
                        <ArrowDownward className={classes.differenceIconDow} />
                        <Typography className={classes.differenceValueDow} variant="body2">
                            {percentual}{'%'}
                        </Typography>
                        <Typography className={classes.caption} variant="caption">
                            {"à menos"}
                        </Typography>
                    </div>
                }
                {
                    percPositivo &&
                    <div className={classes.difference}>
                        <ArrowUpward className={classes.differenceIconUP} />
                        <Typography className={classes.differenceValueUP} variant="body2">
                            {percentual}{'%'}
                        </Typography>
                        <Typography className={classes.caption} variant="caption">
                            {"à mais"}
                        </Typography>
                    </div>
                }

            </CardContent>
        </Card>
    );
};

Budget.propTypes = {
    className: PropTypes.string
};

export default Budget;
